import { render } from "./AddAnggotaKeluarga.vue?vue&type=template&id=ff0d0e7a&scoped=true"
import script from "./AddAnggotaKeluarga.vue?vue&type=script&lang=js"
export * from "./AddAnggotaKeluarga.vue?vue&type=script&lang=js"

import "./AddAnggotaKeluarga.vue?vue&type=style&index=0&id=ff0d0e7a&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff0d0e7a"]])

export default __exports__